import { NextPage } from 'next'
import useInView from 'react-cool-inview'
import styles from '../_playlistsPage.module.scss'
import PlaylistsLayout from '../components/PlaylistsLayout'
import Block from '../../../components/Block'
import { FilterValues } from '../../../components/ui/ListSort'
import { SONGS_LIST_QUERY } from '../../../gql'
import { t } from '../../../utils'
import { staticProps } from '../../../utils/createApolloClient'
import { songsPath } from '../../../utils/routeHelpers'
import buildPopularPlaylist from '../components/buildPopularPlaylist'
import { Song, SortSongsEnum } from '../../../__generated__/graphql'

const PopularPlaylistsPage: NextPage<{
  currentlyTrendingSongs: Song[]
  greatestHitsSongs: Song[]
}> = ({ currentlyTrendingSongs, greatestHitsSongs }) => {
  const CurrentlyTrendingPlaylistBlock = Block(
    buildPopularPlaylist(
      { orderBy: SortSongsEnum.CurrentlyTrending },
      currentlyTrendingSongs
    )
  )
  const GreatestHitsPlaylistBlock = Block(
    buildPopularPlaylist(
      { orderBy: SortSongsEnum.CurrentlyTrending },
      greatestHitsSongs
    )
  )

  const { observe, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve()
  })
  return (
    <PlaylistsLayout>
      <CurrentlyTrendingPlaylistBlock
        title={t('Currently Trending')}
        viewAllText={t('View all')}
        viewAllHref={songsPath({
          orderBy: FilterValues.CURRENTLY_TRENDING
        })}
        blockClasses={`${styles.currentlyTrending} is-12-tablet is-flex-column`}
      />
      <section ref={observe}>
        {inView && (
          <GreatestHitsPlaylistBlock
            title={t('Greatest Hits')}
            viewAllText={t('View all')}
            viewAllHref={songsPath({
              orderBy: 'GREATEST_HITS'
            })}
            blockClasses={`${styles.currentlyTrending} is-12-tablet is-flex-column`}
          />
        )}
      </section>
    </PlaylistsLayout>
  )
}

export const getStaticProps = staticProps({
  additionalProps: async ({ client }) => {
    const {
      data: { songs: currentlyTrendingSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: { perPage: 10, orderBy: FilterValues.CURRENTLY_TRENDING }
    })
    const {
      data: { songs: greatestHitsSongs }
    } = await client.query({
      query: SONGS_LIST_QUERY,
      variables: { perPage: 10, orderBy: FilterValues.GREATEST_HITS }
    })
    return {
      currentlyTrendingSongs,
      greatestHitsSongs
    }
  }
})

export default PopularPlaylistsPage
